import script from "./List.vue?vue&type=script&lang=ts&setup=true"
export * from "./List.vue?vue&type=script&lang=ts&setup=true"

import "./List.vue?vue&type=style&index=0&id=9dcb05c2&scoped=true&lang=css"
script.__scopeId = "data-v-9dcb05c2"

export default script